var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"grid-display"}},[_vm._t("default"),_vm._l((_vm.entities),function(entity){return _c(entity.blockType,{key:_vm.entities.id,tag:"component",attrs:{"entity":entity}})})],2)}
var staticRenderFns = []

export { render, staticRenderFns }